import { styled, Flex } from '@withjoy/joykit';

export const BottomActionsWrapper = styled(Flex)`
  z-index: ${({ theme }) => theme.zIndices.modal};
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;
